import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { GiBlackKnightHelm } from 'react-icons/gi';
import { FaArrowRight } from 'react-icons/fa';

const Card = styled.div`
  height: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  margin-bottom: 30px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5);

    img {
      transform: scale(1.05);
    }
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transition: transform 0.5s ease;
`;

const MintButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  background: linear-gradient(90deg, #8a2be2, #4936ab);
  color: white;
  padding: 10px 20px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  margin-top: 10px;
  transition: all 0.3s ease;

  .icon {
    margin-right: 8px;
    font-size: 1.2rem;
  }

  .arrow {
    margin-left: 8px;
    transition: transform 0.3s ease;
  }

  &:hover {
    background: linear-gradient(90deg, #9d3cf7, #5a46c9);
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(138, 43, 226, 0.4);
    color: white;
    text-decoration: none;

    .arrow {
      transform: translateX(5px);
    }
  }
`;

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const GridItem = styled.div`
  width: 50%;
  padding: 0 15px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const FreeMint = () => {
  const cardOverlayStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: '20px',
    background:
      'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
    zIndex: 2,
    color: 'white',
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '10px',
  };

  const containerStyle = {
    background:
      'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
    minHeight: '100vh',
    padding: '50px 0',
    color: 'white',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '40px',
  };

  return (
    <div style={containerStyle}>
      <Container>
        <div style={headerStyle}>
          <h1
            style={{
              fontSize: '36px',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: '#4da6ff',
            }}
          >
            Select Your Collection
          </h1>
          <p style={{ fontSize: '18px', color: '#ccc' }}>
            Choose a collection to mint from
          </p>
        </div>

        <GridContainer>
          <GridItem>
            <Card>
              <CardImage
                src="https://res.cloudinary.com/dfzcr2ch4/image/upload/v1732089637/dogewarriornft_koyb8l.webp"
                alt="Doge Collection"
              />
              <div style={cardOverlayStyle}>
                <h2 style={titleStyle}>Doge Collection</h2>
                <p>Unlocks Doge Skin for Vega Hero. Woof woof!</p>
                <MintButton to="/doge_mint">
                  <GiBlackKnightHelm className="icon" />
                  Mint Now
                  <FaArrowRight className="arrow" />
                </MintButton>
              </div>
            </Card>
          </GridItem>

          <GridItem>
            <Card>
              <CardImage
                src="https://res.cloudinary.com/dfzcr2ch4/image/upload/v1741255670/shiba_bg_1_bvg7if.webp"
                alt="Shiba Collection"
              />
              <div style={cardOverlayStyle}>
                <h2 style={titleStyle}>Shiba Collection</h2>
                <p>Unlocks Shiba skin for Bjorn Hero</p>
                <MintButton to="/shiba_mint">
                  <GiBlackKnightHelm className="icon" />
                  Mint Now
                  <FaArrowRight className="arrow" />
                </MintButton>
              </div>
            </Card>
          </GridItem>

          <GridItem>
            <Card>
              <CardImage
                src="https://res.cloudinary.com/dfzcr2ch4/image/upload/v1740160230/VEGA_q8sgfs.webp"
                alt="Vega Collection"
              />
              <div style={cardOverlayStyle}>
                <h2 style={titleStyle}>Vega Collection</h2>
                <p>Unlocks Vega Hero</p>
                <MintButton to="/vega_mint">
                  <GiBlackKnightHelm className="icon" />
                  Mint Now
                  <FaArrowRight className="arrow" />
                </MintButton>
              </div>
            </Card>
          </GridItem>

          <GridItem>
            <Card>
              <CardImage
                src="https://nftdrop.magiccraft.io/nft.webp"
                alt="Davinci Collection"
              />
              <div style={cardOverlayStyle}>
                <h2 style={titleStyle}>Davinci Collection</h2>
                <p>Unlocks Davinci Skin for Frigard Hero & More!</p>
                <MintButton to="https://nftdrop.magiccraft.io/">
                  <GiBlackKnightHelm className="icon" />
                  Mint Now
                  <FaArrowRight className="arrow" />
                </MintButton>
              </div>
            </Card>
          </GridItem>
        </GridContainer>
      </Container>
    </div>
  );
};

export default FreeMint;
